export const displayGrade = (value) => {
  if (value === undefined || value === null || isNaN(parseFloat(value))) {
    return "0.00";
  }
  return parseFloat(value).toFixed(2);
};
